import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from './other.i18n';
import { SecondaryDisplayItem } from './secondaryDisplayItem';

export class OtherDetail extends React.Component {
  configurationActive = (fieldName) => {
    if (this.props.capabilities.details.find((x) => x.fieldName === fieldName)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      this.props.other.isNullMessageHolder === false ?
      <div className="clearfix item-row" data-qa={'other_' + this.props.other.description}>
        <div className="col-sm-4 primary-data">
          {
            this.props.other.isPatientReviewed === false ?
             <span className="fa fa-circle"></span> : null
          }
          {this.props.other.description}
        </div>
        <div className="col-sm-8 secondary-data">
            <div className="inline-list">
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.startDate} />}
                value={this.props.other.startDate} language={this.props.language} isDate
                isActive={this.configurationActive('StartDate')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerName} />}
                value={this.props.other.providerName} language={this.props.language}
                isActive={this.configurationActive('ProviderName')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.institution} />}
                value={this.props.other.institution} language={this.props.language}
                isActive={this.configurationActive('Institution')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerPhone} />}
                value={this.props.other.providerPhone} language={this.props.language}
                isActive={this.configurationActive('ProviderPhone')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.providerEmail} />}
                value={this.props.other.providerEmail} language={this.props.language}
                isActive={this.configurationActive('ProviderEmail')}
              />
              <SecondaryDisplayItem label={<FormattedMessage {...messages.labels.comment} />}
                value={this.props.other.comment} language={this.props.language}
                isActive={this.configurationActive('Comment')}
              />
            </div>
        </div>
      </div>
        :
      <div className="col-xs-12 clearfix item-row" data-qa="other_nullMessage">
        <div className="col-sm-4 primary-data">
          {this.props.other.nullMessage}
        </div>
      </div>
    );
  }
}

OtherDetail.propTypes = {
  other: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  capabilities: PropTypes.object.isRequired,
};
